import { GenericService } from "./Generic.service";

export class PersonService extends GenericService<string>{

    readonly URI: string = 'Pessoa'

    constructor(){
        super()
        this.setUri(this.URI);
    }

    /// Funções de pessoa ///

    public async getPessoa(){
        return await super.getByResource('', { PageSize: 500 })
    }

    public async getPessoaById(personId: string){
        return await super.getByResource(`${personId}`)
    }

    public async editPessoaInformation(body: any){
        return await super.put(body)
    }

    public async getPessoaEmpresaByCPF(cpf: string, unitId: string){
        return await super.getByResource('PessoaEmpresaPorCPF', { CPF: cpf, UnidadeAtendimentoId: unitId })
    }

    public async getDependenteByCPF(cpf: string, unitId: string){
        return await super.getByResource('DependentePorCPF', { CPF: cpf, UnidadeAtendimentoId: unitId })
    }

    public async getProfessionalsByCategory(categoryId: string, unitId: string, date: string){
        return await super.getByResource('ProfissionalCombo', { CategoriaId: categoryId, UnidadeAtendimentoId: unitId, Data: date })
    }

    /// Funções de Questionário ///

    public async registerQuestionnaire(personId: string, body: any){
        return await super.postByResource(body, `${personId}/Avaliacao`)
    }

    public async updateQuestionnaire(personId: string, avaliacaoId: string, body: any){
        return await super.putByResource(body, `${personId}/Avaliacao/${avaliacaoId}`)
    }

    public async getAvaliacaoById(avaliacaoId: string, pessoaId: string){
        return await super.getByResource(`${pessoaId}/Avaliacao/${avaliacaoId}`)
    }

    public async getAvaliacaoByPessoaId(questionarioId: string, pessoaId: string){
        if (!pessoaId || pessoaId === 'undefined') {
            return { data: { data: [] } };
        }
        return await super.getByResource(`${pessoaId}/Avaliacao`, { QuestionarioId: questionarioId })
    }
    public async uploadPhoto(body: any){
        return await super.postByResourceHeaders(body, "Foto")
    }

    public async getPhoto(body: any){
        return await super.getByResourcepPhoto(`Foto/${body}`)
    }

    ////// LINHA DE CUIDADO ///////////

    public async getMyCareLines(){
        return await super.getByResource(`LinhaCuidado/Painel`)
    }

    public async getMyCareLinesById(pessoaId: string){
        return await super.getByResource(`${pessoaId}/LinhaCuidado/Painel`)
    }

    ////// MÉDICO DE FAMÍLIA ///////////

    public async getMedicoFamilia(pessoaId: string) {
        return await super.getByResource(`${pessoaId}/MedicoFamilia`);
    }

    public async getMedicosFamiliaCombo() {
        return await super.getByResource(`MedicoFamilia/Combo`);
    }

    public async updateMedicoFamilia(pessoaId: string, medicoFamiliaId: string | null) {
        return await super.patchByResource({ medicoFamiliaId } as any, `${pessoaId}/MedicoFamilia`);
    }

    public async getMeusPacientes(empresaId: string, page: number, pageSize: number, search?: string) {
        return await super.getByResource(`MeusPacientes`, { EmpresaId: empresaId, Page: page, PageSize: pageSize, Search: search });
    }
}
